<template>
  <el-dialog :title="!dataForm.id ? '新增' : '修改'" :modal-append-to-body="false" :show-close="false"
    :close-on-click-modal="false" :visible.sync="visible" width="400px" class="tkye">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
      label-width="100px" style="margin-top: 10px;">
      <el-form-item label="卡号" prop="name">
        <el-input v-model="dataForm.name" placeholder="名称" @blur="checkBlur($event)"></el-input>
      </el-form-item>
      <el-form-item label="设备信息">
        <el-select v-model="dataForm.type" filterable placeholder="请选择设备" style="width: 100%">
          <el-option v-for="item in typeOption" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物联网卡厂商">
        <el-select v-model="dataForm.cardType" placeholder="请选择" style="width: 100%">
          <el-option label="华商物联" :value="0"></el-option>
          <el-option label="齐犇物联" :value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dataFormSubmitvisible()">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      disAble: false,
      poiOption: [],
      typeOption: [],
      enumOption: [],
      noticeOption: [{ label: "开启", value: 0 }, { label: "关闭", value: 1 }],
      dataForm: {
        id: 0,
        type: "",
        name: "",
        cardType: ""
      },
      dataRule: {
        uniqueCode: [
          { required: true, message: "设备ID不能为空", trigger: "blur" }
        ],
        type: [
          { required: true, message: "设备信息不能为空", trigger: "blur" }
        ],
        name: [{ required: true, message: "卡号不能为空", trigger: "blur" }]
      }
    };
  },
  created() {},
  methods: {
    checkBlur(e) {
      this.$http({
        url: this.$http.adornUrl("sim/selectSim/"),
        method: "get",
        params: this.$http.adornParams({
          msisdn: e.target.value,
          cardType: this.dataForm.cardType
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.$message({
            message: data.msg,
            type: "success",
            duration: 1000
          });
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    init(id) {
      this.getDeviceTypeOption();
      this.typeOption = [];
      // this.dataForm.name = []
      // this.dataForm.type = []
      this.visible = true;
    },
    dataFormSubmitvisible() {
      this.visible = false;
      this.typeOption = [];
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(
              `/sim/${!this.dataForm.id ? "save" : "update"}`
            ),
            method: "post",
            data: this.$http.adornData({
              msisdn: this.dataForm.name,
              deviceId: this.dataForm.type,
              cardType: this.dataForm.cardType
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              this.visible = false;
              this.$emit("refreshDataList");
              this.$message({
                message: data.msg,
                type: "success",
                duration: 1000
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    //获取机器型号
    getDeviceTypeOption() {
      this.$http({
        url: this.$http.adornUrl("/sim/deviceList"),
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.typeOption = data.data;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/sim-add-or-update.vue